import request from './request';

export function getCreatorStats() {
  return request.get('/api/creator/stats');
}
export function getMyVideos(params) {
  return request.get('/api/creator/myVideos', { params });
}
export function uploadVideo(data) {
  return request.post('/api/creator/uploadVideo', data);
}
export function deleteVideo(id) {
  return request.post('/api/creator/deleteVideo', { id });
}
export function getDataAnalysis() {
  return request.get('/api/creator/dataAnalysis');
}
